<template>
  <div
    class="base-step"
    :class="{ 'first-base-step':index===0 }"
  >
    <div
      class="step-title"
      v-if="showTitle"
    >
      <div class="order-number">{{ getUnicodeNumber(index) }}</div>
      <div class="order-content">{{ itemData.title }}<span
          class="order-symbol"
          v-if="bothTitleAndContent"
        >：</span></div>
    </div>
    <div
      class="step-content"
      :class="{ 'big-step-content' : !showTitle }"
      v-html="itemData.content"
    ></div>
  </div>
</template>
<script>
import { getUnicodeNumber } from "@/utils/util.js";
export default {
  props: {
    itemData: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    number: {
      type: Number,
      default: 0,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getUnicodeNumber,
  },
  computed: {
    bothTitleAndContent() {
      return (
        this.itemData.title &&
        this.itemData.content !== "" &&
        this.itemData.content !== "<p><br></p>"
      );
    },
  },
};
</script>
<style lang=less scoped>
.base-step {
  // display: flex;
  // align-items: flex-start;
  font-weight: 400;
  // color: #545757;
  font-size: 14px;
  margin-top: 8px;
  .step-title {
    display: flex;
    width: 100%;
    margin-bottom: 8px;
    .order-number {
      margin-top: -1px;
      font-weight: bold;
      margin-right: 3px;
    }
  }

  .order-content {
    flex: 1;
    word-break: break-all;
    white-space: normal;
    min-width: 0;
  }
}
.step-content {
  margin-left: 17px;
}
.big-step-content {
  margin-left: 0;
}
.first-base-step {
  margin-top: 0;
}
</style>